module.exports = __webpack_public_path__ + "img/22.9d976a74.jpg";